import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { SectionLabel, Reveal } from '../components/Section';
import Markdown from '../components/Markdown';

export default function Legal({ slug, title }) {
  const [content, setContent] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setContent(null);
    setFailed(false);
    api
      .policy(slug)
      .then((d) => setContent(d.content))
      .catch(() => setFailed(true));
  }, [slug]);

  return (
    <main className="min-h-screen" data-testid={`legal-${slug}-page`}>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <SectionLabel testid={`legal-${slug}-label`}>{title}</SectionLabel>
        <Reveal>
          <h1 className="mt-5 font-display text-white text-4xl sm:text-6xl">
            {title}<span className="text-[#e8173a]">.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="mt-10 card-surface p-7 sm:p-12" data-testid={`legal-${slug}-content`}>
            {content ? (
              <Markdown content={content} />
            ) : failed ? (
              <p className="text-[#8a8a8a] text-sm">This document is temporarily unavailable. Please check again shortly.</p>
            ) : (
              <div className="space-y-4 animate-pulse">
                {Array.from({ length: 8 }).map((_, i) => (
                  <div key={i} className="h-4 rounded bg-white/5" style={{ width: `${85 - (i % 3) * 15}%` }} />
                ))}
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </main>
  );
}
